/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


/**
    * Function to animate Most Popular/Best Value badge with Animate.css
    * It ensures animations are applied when badges are fully visible in the viewport.
    */
   (() => {
      // Function to animate the badge with Animate.css
      document.addEventListener('DOMContentLoaded', () => {
        const ANIM_CLASSES = ['animate__animated', 'animate__headShake'];

        function animateBadge(badge) {
          badge.classList.add(...ANIM_CLASSES);
          badge.addEventListener('animationend', () => {
            badge.classList.remove(...ANIM_CLASSES);
          }, { once: true });
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) animateBadge(entry.target);
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.5 // 50% visible is enough
        });

        // Observe existing badges
        document.querySelectorAll('.badge-box.custom-box, .shake-it').forEach((b) => observer.observe(b));

        // Also catch badges that might be injected later
        const mo = new MutationObserver(() => {
          document.querySelectorAll('.badge-box.custom-box, .shake-it').forEach((b) => {
            if (!b.__observed) { observer.observe(b); b.__observed = true; }
          });
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
      });
   })();




// Handle Tier Purchase buttons: clear cart, add correct product, redirect to checkout
// key: comes from snippet 'price-table.liquid'
// using the new verstion 'membership-flow.js.liquid'

// (function () {

//   // TEMP: Disable membership logic on test page
// if (window.location.pathname.includes("membership-logic-test")) {
//   console.warn("[Membership] Live membership JS disabled on test page");
//   return; // EXIT EARLY
// }


//   const tierMap = {
//     '#join-tier-one': {
//       variantId: '42142559076450',
//       sellingPlan: '3406364770', // 1 Month Subscription
//       // sellingPlan: '3711631458', // 1 Month Subscription (Black Friday Offer)
//       key: 'tier-one-entries',
//       bonusKey: 'tier-one-bonus-entries'
//     },
//     '#join-tier-two': {
//       variantId: '42142562975842',
//       sellingPlan: '3406397538', // 1 Month Subscription
//       // sellingPlan: '3711664226', // 1 Month Subscription (Black Friday Offer)      
//       key: 'tier-two-entries',
//       bonusKey: 'tier-two-bonus-entries'
//     }
//   };

//   const buttons = document.querySelectorAll('a[href="#join-tier-one"], a[href="#join-tier-two"]');
//   const entryData = JSON.parse(document.getElementById('tier-entry-data')?.textContent || '{}');

//   buttons.forEach(button => {
//     button.addEventListener('click', async event => {
//       event.preventDefault();

//       const href = button.getAttribute('href');
//       const tier = tierMap[href];

//       const entries = entryData[tier?.key];
//       const bonusEntries = entryData[tier?.bonusKey];

//       if (!tier || !entries) return;

//       const properties = {
//         'Giveaway Entries': entries
//       };

//       if (bonusEntries && parseFloat(bonusEntries) > 0) {
//         properties['Bonus'] = `${bonusEntries} Extra Entries`;
//       }

//       try {
//         // await fetch('/cart/clear.js', { method: 'POST' });

//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: tier.variantId,
//             quantity: 1,
//             selling_plan: tier.sellingPlan,
//             properties: properties
//           })
//         });

//         window.location.href = '/checkout';
//       } catch (error) {
//         alert('Something went wrong while joining the tier. Please try again.');
//       }
//     });
//   });
// })();








// Adds a styled checkbox before each upsell product link in the cart drawer; ticking it simulates a real click on the product's "Add" button.
(function () {
  function enhanceUpsells(root) {
    root.querySelectorAll(".product-upsell__holder").forEach(holder => {
      if (holder.dataset.checkboxInjected) return; // skip duplicates
      holder.dataset.checkboxInjected = "true";

      const linkEl = holder.querySelector(".product-upsell__link");
      const addBtn = holder.querySelector(".product-upsell__btn");

      if (linkEl && addBtn) {
        // Build custom checkbox
        const label = document.createElement("label");
        label.className = "upsell-checkbox";

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";

        const span = document.createElement("span");
        span.className = "checkmark";

        label.appendChild(checkbox);
        label.appendChild(span);

        // Insert before the <a>
        linkEl.parentNode.insertBefore(label, linkEl);

        // On change, simulate "Add" button click
        checkbox.addEventListener("change", () => {
          if (checkbox.checked) {
            ["mousedown", "mouseup", "click"].forEach(eventType => {
              const event = new MouseEvent(eventType, {
                bubbles: true,
                cancelable: true,
                view: window
              });
              addBtn.dispatchEvent(event);
            });
          }
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const target = document.querySelector(".cart__widget__products");
    if (target) enhanceUpsells(target);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches(".product-upsell__holder")) {
              enhanceUpsells(node.parentNode);
            } else if (node.querySelectorAll) {
              enhanceUpsells(node);
            }
          }
        });
      });
    });

    if (target) {
      observer.observe(target, { childList: true, subtree: true });
    }
  });
})();







// dependency: \snippets\cart-entries.liquid
// Syncs giveaway entries related DOM content and line item properties with cart updates using a fetch interceptor
// Monitors cart changes and updates entry display + line item properties accordingly
// Total Entries, Giveaway Entries, Bonus Entries
// for preset bundles- not TIERs
let isInternalCartUpdate = false;

(function () {
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    const url = args[0];

    if (
      !isInternalCartUpdate &&
      typeof url === 'string' &&
      url.includes('/cart/') &&
      (
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add') ||
        url.includes('/cart.js')
      )
    ) {
      response.clone().json().then((cart) => {
        updateEntriesDisplayAndProperties(cart);
      });
    }

    return response;
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then((res) => res.json())
    .then(updateEntriesDisplayAndProperties);
});

function updateEntriesDisplayAndProperties(cart) {
  if (!cart || !Array.isArray(cart.items)) return;

  const templates = document.querySelectorAll('.entries-template');

  templates.forEach((template) => {
    const variantId = parseInt(template.dataset.variantId, 10);
    const giveaway = parseInt(template.dataset.giveaway, 10) || 0;
    const bonus = parseInt(template.dataset.bonus, 10) || 0;
    const qty = parseInt(template.dataset.qty, 10) || 0;
    const total = parseInt(template.dataset.total, 10) || 0;

    const display = document.querySelector(`.entries-display[data-total][data-variant-id="${variantId}"]`) 
                  || document.querySelector(`.entries-display[data-total="${total}"]`);
    if (!display || (giveaway === 0 && bonus === 0 && total === 0)) return;


    const expectedHTML = (qty > 1)
      ? `<p class="cart__item__property">Giveaway Entries (per pack): ${giveaway}</p>
         ${bonus > 0 ? `<p class="cart__item__property">Bonus Entries (per pack): ${bonus}</p>` : ''}
         <p class="cart__item__property"><strong>Total Entries (${qty} packs): ${total}</strong></p>`
      : `<p class="cart__item__property">Giveaway Entries: ${giveaway}</p>
         ${bonus > 0 ? `<p class="cart__item__property">Bonus Entries: ${bonus}</p>` : ''}
         <p class="cart__item__property"><strong>Total Entries: ${total}</strong></p>`;

    const existingHTML = display.innerHTML.trim().replace(/\s+/g, ' ');
    const expectedStripped = expectedHTML.trim().replace(/\s+/g, ' ');

    const expectedProps = {
      ...(giveaway > 0 && { 'Giveaway Entries': giveaway }),
      ...(bonus > 0 && { 'Bonus Entries': bonus }),
      ...(total > 0 && { 'Total Entries': total })
    };


    if (existingHTML !== expectedStripped) {
      display.innerHTML = expectedHTML;
    }

    const item = cart.items.find(item => {
      return (
        item.variant_id === variantId &&
        item.quantity === qty &&
        compareProperties(item.properties, expectedProps)
      );
    });

    if (!item) {
      updateMatchingLineItem(cart.items, variantId, qty, expectedProps);
      return;
    }

    let needsUpdate = false;
    for (const key in expectedProps) {
      const expectedVal = String(expectedProps[key]);
      const currentVal = String(item.properties?.[key] || '');
      if (expectedVal !== currentVal) {
        needsUpdate = true;
        break;
      }
    }

    if (needsUpdate) {
      updateLineItemProperties(item.key, qty, expectedProps);
    }
  });
}

function compareProperties(current, expected) {
  for (const key in expected) {
    if (String(current?.[key] || '') !== String(expected[key])) {
      return false;
    }
  }
  return true;
}

function updateMatchingLineItem(items, variantId, quantity, newProps) {
  const fallbackItem = items.find(item => item.variant_id === variantId);

  // Prevent infinite loop: only try to update if fallback item has any entries-related properties
  if (
    fallbackItem &&
    Object.keys(newProps).length > 0
  ) {
    const currentProps = fallbackItem.properties || {};
    if (
      fallbackItem.quantity === quantity &&
      compareProperties(currentProps, newProps)
    ) {
      return;
    }
    updateLineItemProperties(fallbackItem.key, quantity, newProps);
  }

}

function updateLineItemProperties(lineKey, quantity, newProperties) {
  isInternalCartUpdate = true;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      quantity,
      properties: newProperties
    })
  })
    .then(res => res.json())
    .then(updateEntriesDisplayAndProperties)
    .finally(() => {
      isInternalCartUpdate = false;
    });
}


// random animation start delaty to badges shine - randomizes the initial start delay for each
// document.querySelectorAll('.custom_sd .badge-box.sale-box').forEach(el => {
//   const offset = (Math.random() * 2).toFixed(2); // random 0–2s delay
//   el.style.setProperty('--shine-start', `${offset}s`);
// });






// Enables mobile tap-to-switch, safe: activates only when a hover image exists and never blocks normal clicks
// for multicolumn.liquid
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('.column__image').forEach(el => {

//     const hoverImg = el.querySelector('.column-hover-image-wrapper');
//     if (!hoverImg) return; // skip if no hover image

//     let tappedOnce = false;

//     el.addEventListener('touchstart', function (e) {
//       // First tap → show hover image
//       if (!tappedOnce) {
//         tappedOnce = true;
//         el.classList.add('is-tapped');

//         // After a short delay, allow link taps again
//         setTimeout(() => { tappedOnce = false }, 400);
//         e.preventDefault(); // prevent link from opening on first tap
//       }
//       // Second tap → allow normal click (link opens)
//     });
//   });
// });



// pricing table - monthly yearly toggle
// pricing table - monthly yearly toggle
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.pricing-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    try {
      const toggle = wrapper.querySelector('.pricing-toggle');
      const options = wrapper.querySelectorAll('.toggle-option');
      const prices = wrapper.querySelectorAll('.price-value');
      const links = wrapper.querySelectorAll('[data-monthly-link]');
      const notes = wrapper.querySelectorAll('.plan-note');
      const entries = wrapper.querySelectorAll('.entries-value');
      
      // ADDED: Select the new bonus note paragraphs
      const entryNotes = wrapper.querySelectorAll('.entries-note'); 
      
      const features = wrapper.querySelectorAll('[data-show]');

      if (!toggle || !options.length) return;

      function updateUI(plan) {
        toggle.classList.toggle('monthly', plan === 'monthly');
        toggle.setAttribute('aria-checked', plan === 'monthly');

        options.forEach(btn => {
          btn.classList.toggle('active', btn.dataset.plan === plan);
        });

        prices.forEach(el => {
          const value = el.dataset?.[plan];
          if (!value) return;

          const main = el.querySelector('.main-price');
          const compare = el.querySelector('.comp-price');

          if (main) main.textContent = `$${value}`;

          if (compare) {
            const comp = el.dataset?.[plan + 'Compare'];

            if (comp) {
              compare.textContent = `$${comp}`;
              compare.style.display = 'inline-block'; 
            } else {
              compare.style.display = 'none';
            }
          }
        });

        links.forEach(link => {
          const href = link.dataset?.[plan + 'Link'];
          if (href) link.href = href;
        });

        notes.forEach(el => {
          const value = el.dataset?.[plan];
          if (value) el.innerHTML = value;
        });

        entries.forEach(el => { 
          const value = el.dataset?.[plan];
          if (value) el.innerHTML = value;
        });

        // ADDED: Handle the bonus note text show/hide logic
        entryNotes.forEach(el => {
          const value = el.dataset?.[plan];
          
          // If the liquid passed an empty string, 'value' will be falsy
          if (value) {
            el.textContent = value; // textContent is safer here since it's plain text
            el.style.display = '';  // Restore default display
          } else {
            el.style.display = 'none'; // Hide it completely if there's no bonus text
          }
        });

        features.forEach(el => {
          const show = el.dataset?.show || '';
          const allowed = show.split(',').map(v => v.trim());
          el.style.display = allowed.includes(plan) ? '' : 'none';
        });
      }

      options.forEach(btn => {
        btn.addEventListener('click', () => {
          if (!btn.dataset.plan) return;
          updateUI(btn.dataset.plan);
        });
      });

      const defaultPlan = wrapper.dataset?.default || 'yearly';
      updateUI(defaultPlan);

    } catch (e) {
      console.warn('Pricing toggle skipped due to error:', e);
    }
  });
});








// Simplest possible deterrent against DevTools edits of giveaway-entries hidden inputs.
//
// Drop in: just include this script on product pages. No Liquid changes.
// Usage in theme:
//   1. Upload this file to the theme's assets/ folder.
//   2. Add this line in layout/theme.liquid (or only on product pages):
//        {{ 'entries-guard.js' | asset_url | script_tag }}
//
// Threat model: a casual user opens DevTools, edits value="10000" to value="999999",
// or runs `input.value = '999999'` in the console. The lock catches both.
//
// NOT defeated: curl to /cart/add.js, DevTools Local Overrides on this file,
// JS disabled. Those need a server-side check (Shopify Flow on order paid),
// which is the deferred plan in PLAN-server-side-entries-prevention.md.

(() => {
  const NAMES = ['properties[Giveaway Entries]', 'properties[Bonus Entries]'];

  NAMES.forEach(function (name) {
    document.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
      const trusted = input.value;

      // Lock the .value IDL property. Getter returns trusted, setter is a no-op.
      // configurable: false prevents redefining the descriptor.
      Object.defineProperty(input, 'value', {
        configurable: false,
        enumerable: true,
        get: function () { return trusted; },
        set: function () { /* swallow external writes */ }
      });

      // Revert any setAttribute('value', X) edits made via the Elements panel.
      let internal = false;
      new MutationObserver(function () {
        if (internal) return;
        if (input.getAttribute('value') !== trusted) {
          internal = true;
          input.setAttribute('value', trusted);
          internal = false;
        }
      }).observe(input, { attributes: true, attributeFilter: ['value'] });
    });
  });
})();